import { breakpoints } from '../../utils/breakpoints'

const weirdCustomBreakpoint = 1280

export const onMobile = `@media (max-width: ${breakpoints[0]}px)`
export const onDesktop = `@media (min-width: ${weirdCustomBreakpoint}px)`
export const onTablet = `@media (min-width: ${breakpoints[0]}px)`

export const getIsDesktop = (width: number): boolean =>
  width >= weirdCustomBreakpoint

export const getIsTablet = (width: number): boolean =>
  breakpoints[0] < width && width < weirdCustomBreakpoint
